import axios from 'axios';

const axiosConfig = axios.create({
    baseURL: ''
})

export default axiosConfig;
